<template>
  <section class="screen">

<div class="screen__meta meta-overlay spacer-bottom">
  <div class="screen__user">

    <div @click="$router.push('/user/' + activePatient.payload.uid)" v-if="activePatient.active" class="screen__user-image">
      <img src="/static/user.svg">
    </div>

    <span v-if="activePatient.active">{{activePatient.payload.displayName}}</span>
    <span v-else>Select Patient</span>
    <span class="number">707.123.1234</span>

    </div>

</div>
    <div class="screen__card">
      <div class="screen__meta meta-overlay">
        <span class="card-title">Dental Radar</span>

        <!-- <span>Provider</span><br>
        <span>Dr. Timothy Wieg, DDS</span> -->
      </div>

      <div class="screen__meta">
        <div class="edit-container">
          <div class="screen__edit">+</div>
        </div>
        <!-- <p class="description">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequatur culpa cum provident, vero voluptatum deleniti ut, eaque consectetur sit?</p> -->
        <textarea class="description" v-model="description" placeholder="details"></textarea>
 
      </div>
      <div class="screen__services">
        <div class="radar">
          <img src="/static/radar-image.png" alt="dental radar image">
        </div>
      </div>

    </div>

    <div class="screen__actions">
      <span>Confirm Request</span>
      <span @click="submitCard(activePatient.payload)" class="submit">Update</span>
    </div>

<!-- <div v-for="(display, idx) in users" class="tab" :key="idx" @click="$router.push('/user/' + display.uid)">
        <div class="tab__type bg-12"></div>
        <h2 class="tab__name">{{ display.displayName}}</h2>
    </div> -->



  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main"
import * as firebase from "firebase"
import { mapMutations, mapGetters } from 'vuex'
import { Kalendar } from 'kalendar-vue';
import 'kalendar-vue/dist/KalendarVue.css'

console.log(Kalendar)

export default {
  name: 'timeline',
  data () {
    return {
    users: {},
    description: null
    }
  },
firestore() {
    return {
      users: firestore.collection('users')
  }
},
components: {
  Kalendar
},
  watch: {

  },
  methods: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ]),
    submitCard(payload){
      const createdAt = new Date()
      this.description == null
      ? this.description = 'New Media Uplaoded'
      : this.description = 'New Media Uplaoded: ' + this.description

      firestore.collection('cards').add({
        createdAt: createdAt,
        pid: this.user.uid,
        uid: payload.uid,
        type: 'MA',
        description: this.description
      })
      .then((data)=> {
        firestore.collection('cards').doc(data.id).update({
          id: data.id
        })
        .then((data) => {
          this.$router.push('/timeline')
        })
      })
    }
  },
  computed: {
    getState() {
      return this.$store.state;
    },
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading',
      'activePatient'
    ]),
    // activePatient() {
    //   return this.$store.state.activePatient
    // },
    addEvent(popup_data, form_data) {
  let payload = {
    data: {
      title: this.new_appointment.title,
      description: this.new_appointment.description,
    },
    from: popup_info.start_time,
    to: popup_info.end_time,
  };

  this.$kalendar.addNewEvent(
    payload,
  );
  this.$kalendar.closePopups();
  this.clearFormData();
},

// Remove Event
removeEvent(kalendarEvent) {
  let day = kalendarEvent.start_time.slice(0, 10);
  this.$kalendar.removeEvent({
    day,
    key: kalendarEvent.key,
    id: kalendarEvent.kalendar_id,
  })
}
  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

  .radar {
    width: 90%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }

.screen {
    display: flex;
    flex-direction: column;
    flex-flow: wrap;
    padding: 0 0;
    width: 100%;
    align-items: center;
    position: relative;
    font-family: "avenir", sans-serif;
    color: #fff;
    font-weight: bold;

    .edit-container {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__edit {
      width: 20px;
      height: 20px;
      background-color: #A45BEF;
      border-radius: 50%;
      border: 1px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 10px;
      font-weight: bold;
      transform: scale(1);
      transition: all .3s ease-in-out;
      // &:hover {
      //   transform: scale(1.2);
      // }
    }

    .meta-overlay {
      background-color: rgba(0, 0, 0, 0.2);
    }
    .spacer-bottom {
      margin-bottom: 2em;
    }

    &__meta {
      width: 100%;
      height: auto;
      padding: 25px 0;
      border-top-right-radius: 30px;
      border-top-left-radius: 30px;
      margin: 0 auto;
      border-bottom: 1px solid #3E4051;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: center;

      .card-title {
        font-weight: 100;
        padding: 0 1em;
      }
      .description {
        width: 80%;
        margin: 0 auto;
        padding: 5px;
        font-weight: 100;
        background-color: transparent;
        color: #fff;
        outline: none;
        border: none;
        // display: flex;
        // align-items: center;
        // justify-content: center;

        &::placeholder {
          color: #fff;
          padding: 5px;

        }
      }
    }

    &__services {
      display: flex;
      flex-direction: row;
      padding: 20px 0;
      font-size: 10px;
      text-transform: uppercase;
      width: 90%;
      margin: 0 auto;
      letter-spacing: 1px;

      .service-tab {
        background-color: #eee;
        width: 80%;
        margin: 10px 0 0 0;
        padding: 10px;
        border-radius: 5px;
        color: #333;
      }
      .specific {
        width: 60%;
        text-align: left;
        justify-content: left;
        align-items: left;
        font-size: 14px;
      }
      .general {
        width: 40%;
        text-align: left;
        justify-content: left;
        align-items: left;
        font-size: 10px;
          .service-tab {
            width: 90%;
          }
      }
    }

    &__user {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin: 0 auto;

      span {
        width: auto;
        text-align: left;
      }
      .number {
        color: #427ACA;
        font-weight: lighter;
      }

    }
    &__user-image {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border: 1px solid #574AFF;
    border-radius: 50%;
    margin: 0 0 10px 0;
      img {
        width: 35px;
      }

      &::after {
        content: "+";
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        height: 15px;
        background-color: #A45BEF;
        border-radius: 50%;
        border: 1px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
      }
  
    }

    &__card {
      position: relative;
      width: 90%;
      height: auto;
      background-color: transparent;
    //   background: linear-gradient(0.25turn, #00BC84, #00BC84, #22cdd8);
      margin: 1em auto 2em auto;
      border-radius: 30px;
    }

    .schedule {
      background-color: #D7D4FF;
    }
    .progress {
      background-color: #00D194;
    }

    &__actions {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;
      .submit {
        color: #FF0000;
        border: 1px solid #FF0000;
        width: 50%;
        margin: 1em auto 3em auto;
        padding: 5px 10px;
      }
    }
    .tab {
        width: 24vw;
        height: 20vw;
        padding: 20px 30px;
        border-radius: 20px;
        margin: 1vw auto;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: left;
        justify-content: center;
        color: #333;
        cursor: pointer;
        background-color: #fff;

        @media screen and (max-width: $break-small) {
          width: 44vw;
          height: 42vw;
          margin: 3vw auto;
        }

        &:hover {
            // opacity: 0.9;
        }

        h2 {
          font-size: 1.5vw;
          text-align: left;
          text-transform: uppercase;
          font-family: "futura", sans-serif;
          font-weight: 500;
          letter-spacing: 1px;
          width: 100%;
          padding-left: 20px;
          @media screen and (max-width: $break-small) {
            font-size: 3vw;

          }
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: 20px;
        }

            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
}

  
</style>



// WEBPACK FOOTER //
// src/components/DentalRadar.vue